import React, { useMemo } from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';

import { IssueReportType } from 'api/submitIssueReport';
import usePopup from 'hooks/usePopup';

import ReportAnIssueModal from './ReportAnIssueModal';

const useReportAnIssueModal = ({
  type,
  gadgetName,
}: {
  type: IssueReportType | GadgetType;
  gadgetName?: string;
}) => {
  const { isOpen, open, close } = usePopup();

  const modal = useMemo(
    () => (
      <ModalTransition>
        {isOpen && (
          <ReportAnIssueModal
            type={type}
            gadgetName={gadgetName}
            close={close}
          />
        )}
      </ModalTransition>
    ),
    [isOpen, type, gadgetName, close],
  );

  return { open, modal };
};

export default useReportAnIssueModal;
